import React from 'react';
import { Modal, Button, Image } from 'react-bootstrap'; // Added Image for displaying the logo

const ViewDevModal = ({ show, handleClose, dev }) => {
    if (!dev) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View Developer Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
{/* Logo */}
<div className="mb-3 text-center">
    {dev.logo && (
        <Image
            src={dev.logo}
            alt={`${dev.name} Logo`}
            style={{ maxWidth: '200px', maxHeight: '200px', cursor: 'pointer' }}
            fluid
            onClick={() => window.open(dev.logo, '_blank')}
        />
    )}
</div>



                {/* Name */}
                <div className="mb-3">
                    <strong>Name:</strong> {dev.name}
                </div>

                {/* Name */}
                <div className="mb-3">
                    <strong>Developer Sales:</strong> {dev.email}
                </div>


                {/* Contact Number */}
                <div className="mb-3">
                    <strong>Contact Number:</strong> {dev.contactNumber}
                </div>

                {/* Address */}
                <div className="mb-3">
                    <strong>Address:</strong> {dev.address}
                </div>

                {/* IBAN */}
                <div className="mb-3">
                    <strong>IBAN:</strong> {dev.iban}
                </div>

                {/* SWIFT Code */}
                <div className="mb-3">
                    <strong>SWIFT Code:</strong> {dev.swiftCode}
                </div>

                {/* Name of Account */}
                <div className="mb-3">
                    <strong>Name of Account:</strong> {dev.nameOfAccount}
                </div>

                {/* Bank Name */}
                <div className="mb-3">
                    <strong>Bank Name:</strong> {dev.bankName}
                </div>

                {/* Branch Number */}
                <div className="mb-3">
                    <strong>Branch Number:</strong> {dev.branchNumber}
                </div>

                {/* Bank Address */}
                <div className="mb-3">
                    <strong>Bank Address:</strong> {dev.bankAddress}
                </div>

                {/* Segel Name */}
                <div className="mb-3">
                    <strong>Segel Name:</strong> {dev.segelName}
                </div>

                {/* Segel Number */}
                <div className="mb-3">
                    <strong>Segel Number:</strong> {dev.segelNumber}
                </div>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewDevModal;
